module.exports = __webpack_public_path__ + "static/media/clanwilliam.6877e515.png";